// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"948":"532faadc597169e3","6790":"8fe5f939105b71e3"}[chunkId] + ".css";
};